export default __webpack_public_path__ + "static/media/assets-generators.799952f0.gif";